import React, { Component } from "react";
import { Link } from "react-router-dom";

import "../App.css";

import { Button } from "@chakra-ui/react";

import Navbar from "../Componets/TopNavbar";
import Sidenav from "../Componets/SideNav/SideNav";
import BoardComponent from "../Componets/Board";
import ModalBox from "../Componets/ModalBox";

import { deleteBord, getAllboards, createBord } from "../../src/Api/apis";

export default class App extends Component {
  state = {
    bordData: [],
    isModalOpen: false,
    isEditClicked: false,
    bordId: "",
    Name: "",
    backgroundImg: "",
  };

  allboardsInfo = () => {
    const allboards = getAllboards();

    allboards.then((boards) => {
      this.setState({ bordData: boards });
    });
  };

  addBord = (name) => {
    const boardInfo = createBord(name);

    boardInfo.then((board) => {
      const data = board;
      console.log(data);
      this.setState({ bordData: [...this.state.bordData, data] });
    });
  };

  removeBoard = (id) => {
    deleteBord(id);
    let updatedList = this.state.bordData.filter((data) => data.id !== id);
    this.setState({ bordData: updatedList });
    this.setState({ isEditClicked: false });
  };

  clcikedEditor = (id, name) => {
    this.setState({ isEditClicked: true });
    this.setState({ bordId: id });
    this.setState({ Name: name });
  };

  handlemodalBoxOpen = () => {
    this.setState({ isModalOpen: true });
  };

  handlemodalBoxClose = () => {
    this.setState({ isModalOpen: false });
    console.log("hello");
  };

  onSave = (boardName) => {
    this.addBord(boardName);
    this.setState({ isModalOpen: false });
  };

  handleImageSelect = (img) => {
    this.setState({ backgroundImg: img });
  };

  componentDidMount() {
    this.allboardsInfo();
  }

  render() {
    return (
      <div>
        <Navbar />

        <div style={{ display: "flex" }}>
          <div className="left-sec-container">
            <Sidenav />
          </div>

          <div className="rightSec-container">
            <span
              style={{ fontsize: "20px", color: "#A7BBC7", fontWeight: "bold" }}
            >
              YOUR WORKSPACES
            </span>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {this.state.bordData.map((item) => {
                return (
                  <div id="card">
                    <Link
                      to={{
                        pathname: `/boards/${item.id}`,
                        state: { backgroundImg: this.state.backgroundImg },
                      }}
                      style={{ textDecoration: "none", color: "#716F81" }}
                    >
                      <BoardComponent
                        data={item}
                        delete={this.deleteBord}
                        id={item.id}
                        backroundIMG={this.state.backgroundImg}
                      />
                    </Link>
                    <div id="buttongroup">
                      <button
                        onClick={() => this.removeBoard(item.id)}
                        style={{ marginRight: "10px", padding: "5px" }}
                      >
                        delete
                      </button>
                    </div>
                  </div>
                );
              })}
              <div>
                <Button
                  style={{
                    marginTop: "60px",
                    width: "200px",
                    height: "100px",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                  onClick={this.handlemodalBoxOpen}
                >
                  Create new bord
                </Button>
              </div>
            </div>
            {this.state.isModalOpen && (
              <ModalBox
                open={this.state.isModalOpen}
                close={this.handlemodalBoxClose}
                handleSave={this.onSave}
                setImageBackground={this.handleImageSelect}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
